import { Col, Row } from 'antd'
import { transparentize } from 'polished'
import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { Flex } from '../styles/styled-common'

const ItemContainer = styled.div`
  background: ${p => p.theme.offBlack};
  border-radius: 8px;
  margin-bottom: 2em;
  overflow: hidden;
`

const SummaryContainer = styled(Flex)`
  background: ${p => transparentize(0.6, p.theme.antLink)};
  position: relative;
  border-bottom-right-radius: 8px;
`
const SummaryHeadline = styled.div`
  background: ${p => transparentize(0.6, p.theme.antLink)};
  padding: 6px;
  flex: 184px 0 0;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 8px;
  font-family: 'Kanit';
  font-weight: bold;
`

const Title = styled.div`
  text-align: center;
  font-family: 'Saira';
  font-weight: 500;
  margin-bottom: 4px;
`

const StCol = styled(Col)`
  margin-top: 20px;
  ${'' /* border-bottom: 2px solid #fff; */};
`

export default class HostsListItem extends PureComponent {
  render() {
    const { host, columns, ...props } = this.props

    return (
      <ItemContainer {...props}>
        <Row
          gutter={{
            xs: 2,
            sm: 3,
            md: 3,
            lg: 8,
            xl: 20,
            xxl: 20,
          }}
          style={{ padding: '10px 20px' }}
          type="flex"
          justify="space-between"
        >
          {columns
            .filter(({ mobile }) => mobile && mobile.visible !== false)
            .map(({ render, columnKey, title, mobile: { span } }) => (
              <StCol key={columnKey} span={span}>
                <Title>{title}</Title>
                {render(host, true)}
              </StCol>
            ))}
        </Row>

        {false && host.notes && (
          <SummaryContainer flexWrap="nowrap" justifyContent="start">
            <SummaryHeadline>SUMMARY</SummaryHeadline>
            <div style={{ flex: 'auto 1', padding: '4px 8px 4px 16px' }}>
              {host.notes.map((note, i) => (
                <span key={i}>
                  {note}
                  {i < host.notes.length - 1 ? (
                    <span style={{ margin: '0 10px' }}>•</span>
                  ) : null}
                </span>
              ))}
            </div>
          </SummaryContainer>
        )}
      </ItemContainer>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/HostsListItemMobile.jsx